import { useTheme } from "@mui/material/styles";

export function useChartColors(count: number): string[] {
  const theme = useTheme();
  const chart = theme.palette.chart;

  const colors = chart.series.map((s: { fg: string }) => s.fg);

  return colors.slice(0, Math.min(count, colors.length));
}
